import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from "@/components/ui/credenza"
import ConnectionTypesForm from "@/components/forms/connection-types-form"
import { Icons } from "@/components/icons"

export const Route = createFileRoute(
  '/_home/meter-connection-settings/connection-type/add',
)({
  component: AddConnectionTypesPage,
})

export default function AddConnectionTypesPage() {
  const [showAddConnectionTypeModal, setShowAddConnectionTypeModal] =
    React.useState<boolean>(false)
  return (
    <main className="space-y-4 p-4">
      {/*  <Dialog>
        <DialogTrigger asChild>
          <Button>
            <Icons.add className="size-4" />
            Add Connecttion Type
          </Button>
        </DialogTrigger>
        <DialogContent className="md:max-w-[850px]">
          <ConnectionTypesForm />
          <DialogFooter className="flex flex-row justify-end gap-2 md:mr-4">
            <DialogClose>
              <Button variant="outline" type="submit" className="w-28">
                Cancel
              </Button>
            </DialogClose>
            <Button type="submit" className="w-28">
              Add
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog> */}
      <div className="flex w-full justify-end">
        <Button
          onClick={() => {
            {
              if (!validateUserAddPermission()) return
              setShowAddConnectionTypeModal(true)
            }
          }}
        >
          <Icons.add className="size-4" />
          Add Connection Type
        </Button>
      </div>
      <Credenza
        open={showAddConnectionTypeModal}
        onOpenChange={setShowAddConnectionTypeModal}
      >
        <CredenzaContent className="flex w-full max-w-[850px] justify-center">
          <CredenzaBody>
            <ConnectionTypesForm
              setShowAddConnectionTypeModal={setShowAddConnectionTypeModal}
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
